export default __webpack_public_path__ + "static/media/UnplannedCardBg.e63a571b.svg";